import { Link } from 'react-router-dom';
import { StatePanel } from '@3dspinit/ui';

export function WorldsPage() {
  return (
    <main className="page">
      <h1 style={{ fontFamily: 'var(--font-display)' }}>Worlds & rooms</h1>
      <StatePanel
        variant="default"
        title="Room templates"
        message="Private Museum, Music Room and Man Cave templates are available when FEATURE_ROOMS is enabled. Multiplayer pilot target: eight participants for thirty minutes."
      />
      <p style={{ marginTop: '1rem' }}>
        <Link className="btn" to="/connect">
          Connect destinations
        </Link>
      </p>
    </main>
  );
}
